import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import { parseToEasternTime } from './../../utils/dates';
import { useGetEscalationMainReasonSubReasonQuery } from '../../services/jobsApi';
import { useSelector } from 'react-redux';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderRadius: '1em',
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: 'var(--orange)' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function EscalationsHistory(props) {
  const [expanded, setExpanded] = React.useState('panel0');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  console.log(props.history)

  const escalationReasons = useGetEscalationMainReasonSubReasonQuery();

  function getEscalationReasonName(mainReasonId, subReasonId) {
    if (!escalationReasons?.data) return "";

    let mainReason = escalationReasons.data.find(mainReason=> mainReason.id === mainReasonId);
    if (!mainReason) return "Main Reason Not Found";
  
    let subReason = mainReason.jobEscalationSubReason?.find(subReason => subReason.id === subReasonId);
    if (!subReason) return "Sub Reason Not Found";
  
    return `${mainReason.name} - ${subReason.name}`;
  }

  return (
    <div>
      {
        props.history &&
        (props.history).slice(0).reverse().map((hs, i) =>
          <Accordion expanded={expanded === `panel${i}`} onChange={handleChange(`panel${i}`)} key={i} >
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" sx={{ borderRadius: '1em 1em 0 0' }}>
              <Typography> {parseToEasternTime(hs.issueCreated)} - {hs?.hiveUser?.firstName + " " + hs?.hiveUser?.lastName}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <div className='row-modal'>
                  <div>
                    <p style={{ color: 'var(--orange)', margin: '0 0 1em 0' }} >Escalation Reason</p>
                    <p>
                      {( getEscalationReasonName(hs.jobEscalationMainReasonId, hs.jobEscalationSubReasonId) )}
                    </p>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row' }} >
                    <p style={{ color: 'var(--orange)', marginRight: '1em' }} >Status</p>
                    <p style={{ marginRight: '1em' }}>Escalated</p>
                  </div>

                </div>

              </div>
              <div className='escalation-notes'>
                <div style={{ marginRight: '2em' }}>
                  <p style={{ color: 'var(--orange)', margin: '1em 0' }} >User Notes</p>
                  <p>
                    {hs.issueNote}
                  </p>
                </div>
                <div>
                  <p style={{ color: 'var(--orange)', margin: '1em 0' }} >Internal Notes</p>
                  <p>
                    {hs.issueResolvedNote}
                  </p>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        )
      }

    </div>
  );
}